import First from "../slider/assets/First.jpg";
import Second from "../slider/assets/Second.jpg";
import Third from "../slider/assets/Third.jpg";
import Fourth from "../slider/assets/Fourth.jpg";
import Fifth from "../slider/assets/Fifth.jpg";
import Six from "../slider/assets/Six.jpg";
import Seven from "../slider/assets/Seven.jpg";
import Eight from "../slider/assets/Eight.jpg";
import Nine from "../slider/assets/Nine.jpg";

export default 
 [
  {
    title: "First Slide",
    description: "This is the first slider Image of our carousel",
    urls: First,
  },
  {
    title: "First Slide",
    description: "This is the first slider Image of our carousel",
    urls: Second,
  },
  {
    title: "Second Slide",
    description: "This is the second slider Image of our carousel",
    urls: Third,
  },
  {
    title: "Third Slide",
    description: "This is the Third slider Image of our carousel",
    urls: Fourth,
  },
  {
    title: "Fourth Slide",
    description: "This is the Fourth slider Image of our carousel",
    urls: Fifth,
  },
  {
    title: "Fifth Slide",
    description: "This is the Fifth slider Image of our carousel",
    urls: Six,
  },
  {
    title: "Sixth Slide",
    description: "This is the Sixth slider Image of our carousel",
    urls: Seven,
  },
  {
   " title": "Seventh Slide",
    description: "This is the Seventh slider Image of our carousel",
    urls: Eight,
  },
  {
    " title": "Seventh Slide",
     description: "This is the Seventh slider Image of our carousel",
     urls: Nine,
   },
]
